export default __webpack_public_path__ + "static/media/23.224fb72f.jpg";